import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { AccountSelection, SimplifiedSelectDateRange, SelectGroup } from "commons";
import { TWELVE_MONTHS } from "commons/src/NuDateUtils";

import { routes } from "../../helpers/RouteHelpers";

export function AnalysisConfig({ history, rangeId = TWELVE_MONTHS.id, accountNum = "default" }) {
    const handleSubmit = (accountNum, rangeId) =>
        history.push(routes.client.analysis({ accountNum, rangeId }));
    const handleAccountSelected = event => handleSubmit(event.target.value, rangeId);
    const handleRangeSelected = (_e, date) => handleSubmit(accountNum, date.rangeId);

    return (
        <Container>
            <SelectGroup>
                <AccountSelection
                    handleSelect={handleAccountSelected}
                    value={accountNum}
                    includeCombined
                />
                <SimplifiedSelectDateRange dateChanged={handleRangeSelected} value={rangeId} />
            </SelectGroup>
        </Container>
    );
}

const Container = styled.div`
    margin: auto;
    clear: both;

    @media (min-width: ${props => props.theme.minWidth}) {
        max-width: 860px;
    }
`;

AnalysisConfig.propTypes = {
    accountNum: PropTypes.string,
    rangeId: PropTypes.string,
    history: PropTypes.shape({
        push: PropTypes.func
    })
};
